import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddOrderReservationRelation1698063733631 implements MigrationInterface {
	name = 'AddOrderReservationRelation1698063733631'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "order" ADD "reservationId" uuid`)
		await queryRunner.query(
			`ALTER TABLE "order" ADD CONSTRAINT "UQ_6994cb6e22c6de89b02919ee6fa" UNIQUE ("reservationId")`,
		)
		await queryRunner.query(
			`ALTER TABLE "order" ADD CONSTRAINT "FK_6994cb6e22c6de89b02919ee6fa" FOREIGN KEY ("reservationId") REFERENCES "reservation"("id") ON DELETE NO ACTION ON UPDATE NO ACTION`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "order" DROP CONSTRAINT "FK_6994cb6e22c6de89b02919ee6fa"`)
		await queryRunner.query(`ALTER TABLE "order" DROP CONSTRAINT "UQ_6994cb6e22c6de89b02919ee6fa"`)
		await queryRunner.query(`ALTER TABLE "order" DROP COLUMN "reservationId"`)
	}
}
